// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  touch-action: none;
  margin: 1rem auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
.container .left-box {
  flex: 2.3 1;
  margin-right: 1rem;
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 64vh;
  border: 1px solid #032f40;
  border-radius: 1rem;
}
.container .left-box .dropzone-left {
  flex: 1 1;
  overflow-y: scroll;
  height: 64vh;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;
  width: 26rem;
  flex-flow: row wrap;
}
.container .right-box {
  flex: 5 1;
  align-items: center;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  height: 64vh;
}
.container .right-box .suite-box {
  height: 45vh;
  display: flex;
  margin-right: 1rem;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid #032f40;
  border-radius: 1rem;
}
.container .right-box .suite-box .dropzone-right {
  height: 40vh;
  overflow-y: scroll;
  min-width: 18rem;
}

.grid-item {
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  background-color: #032f40;
  color: #0fc6ee;
  border-radius: 1rem;
  font-weight: 600;
  font-size: 1rem;
  cursor: grab;
}

.url-alert {
  width: 50%;
  height: 12%;
  position: fixed;
  top: 30%;
  right: 25%;
  left: 25%;
  bottom: 48%;
  z-index: 999;
  color: black !important;
  font-weight: 800 !important;
  font-size: 18px !important;
  border: 5px solid #555;
}
.url-alert .url-span-url {
  display: inline;
  width: 50%;
}

.add-suites {
  width: 22%;
  height: 25%;
  position: fixed;
  top: 25%;
  right: 39%;
  left: 39%;
  bottom: 50%;
  z-index: 999;
  border: 5px solid #555;
}
.add-suites .suite-heading {
  margin-left: 6rem;
  color: black;
}
.add-suites .suite-textfield {
  margin-top: 0.5rem;
  margin-left: 4rem;
}
.add-suites .suite-button {
  margin-top: 1.5rem;
  margin-left: 3.5rem;
}
.add-suites .suite-button .suite-cancel-button {
  margin-left: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/CreateCollection/CreateCollection.style.scss"],"names":[],"mappings":"AAAA;EAEE,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA,EAAA,WAAA,EACA,oBAAA;EACA,iBAAA,EAAA,oBAAA;AACF;AACE;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AACJ;AAAI;EACE,SAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EAEA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AACN;AAEE;EACE,SAAA;EACA,mBAAA;EACA,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,YAAA;AAAJ;AACI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AACN;AACM;EACE,YAAA;EACA,kBAAA;EAGA,gBAAA;AADR;;AAOA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAJF;;AAOA;EACE,UAAA;EACA,WAAA;EACA,eAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;EACA,sBAAA;AAJF;AAKE;EACE,eAAA;EACA,UAAA;AAHJ;;AAMA;EACE,UAAA;EACA,WAAA;EACA,eAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAHF;AAIE;EACE,iBAAA;EACA,YAAA;AAFJ;AAIE;EACE,kBAAA;EACA,iBAAA;AAFJ;AAIE;EACE,kBAAA;EACA,mBAAA;AAFJ;AAGI;EACE,iBAAA;AADN","sourcesContent":[".container {\n  display: flex;\n  touch-action: none;\n  margin: 1rem auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE 10 and IE 11 */\n  user-select: none; /* Standard syntax */\n\n  .left-box {\n    flex: 2.3;\n    margin-right: 1rem;\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    height: 64vh;\n    border: 1px solid #032f40;\n    border-radius: 1rem;\n    .dropzone-left {\n      flex: 1;\n      overflow-y: scroll;\n      height: 64vh;\n      display: flex;\n      // padding: 0 1rem;\n      justify-content: space-between;\n      align-items: flex-start;\n      flex-direction: row;\n      width: 26rem;\n      flex-flow: row wrap;\n    }\n  }\n  .right-box {\n    flex: 5;\n    align-items: center;\n    display: flex;\n    justify-content: flex-start;\n    flex-direction: column;\n    height: 64vh;\n    .suite-box {\n      height: 45vh;\n      display: flex;\n      margin-right: 1rem;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: center;\n      border: 1px solid #032f40;\n      border-radius: 1rem;\n\n      .dropzone-right {\n        height: 40vh;\n        overflow-y: scroll;\n\n        // max-width: 18rem;\n        min-width: 18rem;\n      }\n    }\n  }\n}\n\n.grid-item {\n  height: 2.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n  background-color: #032f40;\n  color: #0fc6ee;\n  border-radius: 1rem;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: grab;\n}\n\n.url-alert{\n  width: 50%;\n  height: 12%;\n  position: fixed;\n  top: 30%;\n  right: 25%;\n  left: 25%;\n  bottom: 48%;\n  z-index: 999;\n  color: black !important;\n  font-weight: 800 !important;\n  font-size: 18px !important;\n  border: 5px solid #555;\n  .url-span-url{\n    display: inline;\n    width: 50%;\n  }\n}\n.add-suites{\n  width: 22%;\n  height: 25%;\n  position: fixed;\n  top: 25%;\n  right: 39%;\n  left: 39%;\n  bottom: 50%;\n  z-index: 999;\n  border: 5px solid #555;\n  .suite-heading{\n    margin-left: 6rem;\n    color: black;\n  }\n  .suite-textfield{\n    margin-top: 0.5rem;\n    margin-left: 4rem;\n  }\n  .suite-button{\n    margin-top: 1.5rem;\n    margin-left: 3.5rem;\n    .suite-cancel-button{\n      margin-left: 1rem;\n    }\n  }  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
